import React from "react";
import PropTypes from "prop-types";

import { SuccessButton, Loader } from "../../..";
import { WHITE } from "../../../styles/shared/colors";
import "./Footer.scss";


const Footer = ({ onClick, showLoader })=> {
  return (
    <div className="footer">
      <SuccessButton
        disabled={showLoader}
        onClick={onClick}
        className="footer__confirm-button"
      >
        {showLoader ?
          <Loader type="spokes" color={WHITE}  height={20} width={20} /> :
          "APPLY"
        }
      </SuccessButton>
    </div>
  );
};

Footer.propTypes = {
  onClick: PropTypes.func,
  showLoader: PropTypes.bool
}

Footer.defaultProps = {
  onClick: ()=> {},
  showLoader: false,
}

export default Footer;
